<template>
	<div :class="['p-3', 'sliding-panel', open ? 'open': '']">
		<a href="#" @click.stop.prevent="close" class="sliding-panel-close-btn">
			<i class="fas fa-angle-double-right"></i>
		</a>
		<div class="sliding-panel-content">
			<slot/>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'SlidingPanel',
		props: {
			condition: {
				type: String,
				required: false
			}
		},
		data() {
			return {
				open: false
			}
		},
		methods: {
			check_condition: function (param) {
				param = param.split('=');
				var url_value = this.$URL.get(param[0]);
				if ((param[1] == "*" && url_value != "" && url_value !== null) || url_value == param[1] ) return true;
				return false;
			},
			close: function() {
				var params = this.condition;
				var params2;

				var url = {};
				var or_params = params.split('|');
				for (let i in or_params) {
					params2 = or_params[i];
					params2 = params2.split('&');
					for (let j in params2) {
						let param = params2[j].split('=');
						url[param[0]] = null;
					}
				}
				this.$URL.set(url);
			},
			set_state() {
				var params = this.condition;
				var params2;
				var found = true;
				var has_param = false;

				var or_params = params.split('|');
				for (var i in or_params) {
					params2 = or_params[i].split('&');
					found = params2.every(this.check_condition);
					if (found) 	break;
				}

				if (found) {
					this.open = true;
				}
				else {
					this.open = false;
				}
				//console.log(this.condition);
//				console.log(this.$URL.get('panel'));
			}
		},
		mounted() {
			window.addEventListener('hashchange', this.set_state);
			this.set_state();
		}
	}
</script>

<style scoped lang="scss">
.sliding-panel {
	position: absolute;
	height: 95%;
	min-width: 300px;
	max-width: 500px;
	width: 50%;
	right: -100%;
	top: 2.5%;
	border-radius: 5px 0px 0px 5px;
	background: rgba(0, 0, 0, 0.8);
	transition-duration: 0.4s;
	transition-timing-function: ease;
	transition-property: right;
	color: #fff;
	-webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.75);
	-moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.75);
	box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.75);
	&.open {
		z-index: 1040;
		 right: 0;
	}
	 .sliding-panel-content {
		 position: relative;
		 height: 100%;
		 width: 100%;
		 overflow: auto;
	 }
	.sliding-panel-close-btn {
		position: absolute;
		top: 50%;
		left: 0px;
		font-size: 18px;
		height: 100px;
		margin-top: -50px;
		padding-top: 35px;
		color: #fff;
		display: block;
		background: rgba(255,255,255, 0.6);
		&:hover {
			color: #333333;
			 transition-duration: 0.4s;
			 transition-timing-function: ease;
			 transition-property: color;
		 }
	}
}

</style>
